module.exports = __webpack_public_path__ + "img/38_62.68bab5b3.png";